module.exports = __webpack_public_path__ + "static/media/lefluff.a6182113.svg";